import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import qs from 'query-string';

import * as profileActions from 'actions/profile';

import JournalEntriesComponent from './JournalEntriesComponent';

const INITIAL_STATE = {
  fetchDirection: undefined,
  isFetching: false,
};

export class JournalEntriesContainer extends Component {
  state = { ...INITIAL_STATE };

  componentDidMount = () => {
    const { fetchSharedContent, location, match } = this.props;
    const {
      fromEchoId,
      profileName: characterName,
    } = match.params;

    const fromId = fromEchoId || qs.parse(location.search)['fromEchoId'];

    fetchSharedContent({
      characterName,
      fromId,
    });
  };

  handleFetchDirection = async (direction) => {
    const {
      fetchSharedContentByUrl,
      history,
      match: { params: { profileName } },
      [direction]: url,
    } = this.props;
    if (url) {
      // Retrieve the next/prev data
      this.setState({ isFetching: true, fetchDirection: direction });
      const data = await fetchSharedContentByUrl(url);
      this.setState({ ...INITIAL_STATE });
      const { shares } = data;
      // Update the address bar so that users can share where they are a bit
      // more easily
      if (shares.length) {
        history.replace(`/profile/${profileName}/${shares[0].id}`);
      }
    }
  };

  handleJumpToDate = async (value) => {
    const { fetchSharedContent, history, match: { params } } = this.props;
    const { profileName: characterName } = params;
    const date = moment(value).add(122, 'years').format('YYYY-MM-DD');
    const { shares } = await fetchSharedContent({ characterName, date });
    // Update the address bar so that users can share where they are a bit
    // more easily
    if (shares && shares.length) {
      history.replace(`/profile/${characterName}/${shares[0].id}`);
    }
  };

  handleNext = () => {
    this.handleFetchDirection('next');
  };

  handlePrev = () => {
    this.handleFetchDirection('prev');
  };

  render = () => {
    const {
      next,
      prev,
      sharedContent,
    } = this.props;

    const { fetchDirection, isFetching } = this.state;

    return (
      <JournalEntriesComponent
        fetchDirection={fetchDirection}
        isFetching={isFetching}
        next={next}
        onJumpToDate={this.handleJumpToDate}
        onNext={this.handleNext}
        onPrev={this.handlePrev}
        prev={prev}
        sharedContent={sharedContent}
      />
    );
  }
}

JournalEntriesContainer.displayName = 'JournalEntriesContainer';

JournalEntriesContainer.propTypes = {
  fetchSharedContent: PropTypes.func.isRequired,
  fetchSharedContentByUrl: PropTypes.func.isRequired,
  next: PropTypes.string,
  prev: PropTypes.string,
  sharedContent: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

JournalEntriesContainer.defaultProps = {
  next: null,
  prev: null,
};

const mapStateToProps = ({
  profile: {
    next,
    prev,
    sharedContent,
  },
}) => ({ next, prev, sharedContent });

export default withRouter(connect(mapStateToProps, { ...profileActions })(JournalEntriesContainer));